var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28757 2.1885L0.758403 8.08016C0.68564 8.20617 0.647139 8.34904 0.646732 8.49455C0.646324 8.64005 0.684024 8.78313 0.756081 8.90955C0.828137 9.03596 0.932039 9.14131 1.05745 9.2151C1.18286 9.28889 1.3254 9.32856 1.4709 9.33016H8.52924C8.67474 9.32856 8.81728 9.28889 8.94269 9.2151C9.0681 9.14131 9.172 9.03596 9.24406 8.90955C9.31612 8.78313 9.35382 8.64005 9.35341 8.49455C9.353 8.34904 9.3145 8.20617 9.24174 8.08016L5.71257 2.1885C5.63829 2.06604 5.5337 1.9648 5.4089 1.89453C5.2841 1.82427 5.14329 1.78735 5.00007 1.78735C4.85685 1.78735 4.71604 1.82427 4.59124 1.89453C4.46644 1.9648 4.36185 2.06604 4.28757 2.1885V2.1885Z",
    stroke: "#ED870F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.33008V5.99674",
    stroke: "#ED870F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.66333H5.00417",
    stroke: "#ED870F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellowWarning.fe0fa5cca0db8a6508e723f20e73fc9b.svg";
export { ForwardRef as ReactComponent };